import { MapGroupId } from "../../types";
import img from "../../mapImages/FactoryMain.webp";

const mapData = {
  groupId: MapGroupId.Factory,
  groupName: {
    en: "Factory",
    ru: "Завод",
  },
  title: {
    en: "Main",
    ru: "Главная",
  },
  imgPath: img,
  extracts: [],
};

export default mapData;
